import { TransformConverter } from '@simlab/transform';
import type THREE from 'three';
import {
  BufferGeometry,
  Camera,
  CanvasTexture,
  Clock,
  Color,
  Float32BufferAttribute,
  Group,
  Line,
  LineBasicMaterial,
  Mesh,
  MeshBasicMaterial,
  PlaneGeometry,
  Scene,
  ShapeUtils,
  Sprite,
  SpriteMaterial,
} from 'three';
import { TAreaMeshInputs } from '../types/measurement-tool.interface';
import { Units } from '../types/units.type';
import { mixinAreaMeasurementComponent } from './area-mesh-base';

const _areaMeasurementComponentBase = mixinAreaMeasurementComponent(class { });

export class AreaMeshComponent extends _areaMeasurementComponentBase {
  override transform: TransformConverter;
  private _clock = new Clock();
  override get camera(): Camera {
    return this._camera;
  }
  override get scene(): Scene {
    return this._scene;
  }
  override get cameraContainer(): Camera {
    throw new Error('Method not implemented.');
  }
  override get Group(): typeof Group {
    return this._THREE.Group;
  }
  override get SpriteMaterial(): typeof SpriteMaterial {
    return this._THREE.SpriteMaterial;
  }
  override get Color(): typeof Color {
    return this._THREE.Color;
  }
  override get MeshBasicMaterial(): typeof MeshBasicMaterial {
    return this._THREE.MeshBasicMaterial;
  }
  override get LineBasicMaterial(): typeof LineBasicMaterial {
    return this._THREE.LineBasicMaterial;
  }
  override get CanvasTexture(): typeof CanvasTexture {
    return this._THREE.CanvasTexture;
  }
  override get ShapeUtils(): typeof ShapeUtils {
    return this._THREE.ShapeUtils;
  }
  override get Float32BufferAttribute(): typeof Float32BufferAttribute {
    return this._THREE.Float32BufferAttribute;
  }
  override get PlaneGeometry(): typeof PlaneGeometry {
    return this._THREE.PlaneGeometry;
  }
  override get Mesh(): typeof Mesh {
    return this._THREE.Mesh;
  }
  override get BufferGeometry(): typeof BufferGeometry {
    return this._THREE.BufferGeometry;
  }
  override get Sprite(): typeof Sprite {
    return this._THREE.Sprite;
  }
  override get Line(): typeof Line {
    return this._THREE.Line;
  }
  override set collider(colision: boolean) {
    throw new Error('Method not implemented.');
  }
  constructor(
    private readonly _camera: Camera,
    private readonly _scene: Scene,
    private readonly _THREE: typeof THREE,
    private readonly _transform: TransformConverter,
    private readonly _input: TAreaMeshInputs
  ) {
    super();
    this.transform = _transform;

    this.inputs = {
      ...this.inputs,
      ..._input,
    };
    this.onInit();
    this.animate();

    this.scene.add(this._group);
  }
  protected animate() {
    requestAnimationFrame(() => this.animate());
    // this.clockNow;
    this.animationFrame(this._clock.getDelta() * 1000);
  }
  override destroy(): void {
    this._segmentsLabelGroup?.traverse((obj) => {
      this.scene.remove(obj);
    });
    this._segmentsLabelGroup && this.scene.remove(this._segmentsLabelGroup);

    this._group.traverse((obj) => {
      this.scene.remove(obj);
    });
    this.scene.remove(this._group);
  }
  setColor(color: string) {
    this.color = color;
    this._setLineMaterial();
    this._setPointMaterial();
    this._setAreaMeshMaterial();
  }
  setSurfaceSizeUnit(surfaceSizeUnit: Units) {
    this.inputs.surfaceSizeUnit = surfaceSizeUnit;
    if (!this.surfaceSizeMesh) return;
    this._setSurfaceAreaTexture();
  }
}
